import axios from "axios";

async function callAPI(finalEndpoint, data) {
    let rstatus = false;
    let rmessage = 'Some internal error occurred!';
    let rdata = [];

    const headersforaxios = { 'Content-Type': 'application/json' };
    axios.defaults.withCredentials = true;

    await axios.post(finalEndpoint, data, { headers: headersforaxios })
    .then( res => {
        if (res.data.status){ 
            rstatus = true;
            if (res.data.message){ rmessage = res.data.message; }
            if (res.data.data){ rdata = res.data.data; }
        } else {
            rstatus = false; 
            if (res.data.message){ rmessage = res.data.message; }
        }
    })
    .catch( err => {
        rstatus = false;
        rmessage = err.toString();
    });

    return { rstatus, rmessage, rdata };
}

export default callAPI;